import { initialReducerState } from '../constants/index'
import { useRef } from 'react'

const getRap = ({ minValue = 0, maxValue = 100, step = 1 }) => {
  return Array(Math.ceil((maxValue - minValue) / step) + 1).fill(minValue).map((x, y) => x + y * step)
}

const reducer = (state, action) => {
  const fieldValue = {
    payload: action.payload,
    action: action.type,
    activeInput: state.activeInputName
  }

  switch (action.type) {
    case 'color':
      return { ...state, color: action.payload }
    case 'clarity':
      return { ...state, clarity: action.payload }
    case 'shape':
      return { ...state, shape: action.payload }
    case 'rap':
      return { ...state, rap: action.payload }
    case 'carat':
      return { ...state, carat: castFieldValue({ ...fieldValue, stateValue: state.carat }) }
    case 'price':
      return { ...state, price: castFieldValue({ ...fieldValue, stateValue: state.price }) }
    case 'priceTotal':
      return { ...state, priceTotal: castFieldValue({ ...fieldValue, stateValue: state.priceTotal }) }
    case 'priceInitial':
      return { ...state, priceInitial: action.payload }
    case 'priceTotalInitial':
      return { ...state, priceTotalInitial: action.payload }
    case 'backspace':
      return { ...state, ...handleBackSpace(state) }
    case 'activeInputName':
      return { ...state, activeInputName: action.payload }
    case 'resetAllInputs':
      return { ...state, price: '0', priceTotal: '0', priceInitial: '0', priceTotalInitial: '0', carat: '0' }
    default:
      return { ...initialReducerState }
  }
}

const castFieldValue = ({ stateValue, payload, action, activeInput }) => {
  switch (true) {
    case payload === 'reset':
      return '0'
    case stateValue.includes('.') && payload === '.':
      return stateValue
    case stateValue.includes('.'):
      const [before, after] = (stateValue + payload).split('.')
      const value = [before, after.slice(0, 2)].join('.')
      return (value)
    case payload === '.':
      if (parseFloat(stateValue) >= 999) {
        return stateValue
      }
      return stateValue + payload
    default:
      return handleActiveInputValue({ stateValue, payload, action, activeInput })
  }
}

const handleActiveInputValue = ({ stateValue, payload, action, activeInput }) => {
  switch (true) {
    case action === 'price':
      if (activeInput === 'price') {
        return stateValue.replace(/^0+/, '') + payload
      } else {
        return payload.toString()
      }
    case action === 'priceTotal':
      if (activeInput === 'priceTotal') {
        return stateValue.replace(/^0+/, '') + payload
      } else {
        return payload.toString()
      }
    default:
      const newValue = stateValue.replace(/^0+/, '') + payload
      if (newValue && (newValue > 999)) {
        return stateValue
      }
      return newValue
  }
}

const handleBackSpace = (state) => {
  return { [state.activeInputName]: state[state.activeInputName].length > 1 ? state[state.activeInputName].slice(0, -1) : '0' }
}

const useMultiplyRefs = (swiperLength) => {
  return new Array(swiperLength).fill({}).map(() => useRef(null))
}

export {
  getRap,
  reducer,
  useMultiplyRefs
}
